import React, { useMemo } from 'react'
import styles from './styles'

const MessageNotificationBadge = ({ count = 0, children }) => {
  const label = useMemo(() => {
    if (count > 99) {
      return '+99'
    }
    return String(Math.max(0, Math.floor(count)))
  }, [count])

  if (!count || count < 1) {
    return children
  }

  return (
    <span style={styles.anchor}>
      {children}
      <span style={styles.pill} aria-label={`Unread messages: ${label}`}>
        <span style={styles.label}>{label}</span>
      </span>
    </span>
  )
}

export default MessageNotificationBadge
